import { QueryObserverResult, useQuery } from '@tanstack/react-query';

import { API_QUERY_KEYS, GetConsulteeTeamsResponse, QueryDefaults } from 'api';
import { getConsulteeTeams } from '../methods/get/getConsulteeTeams';

export const useConsulteeTeams = (): QueryObserverResult<GetConsulteeTeamsResponse> =>
  useQuery([API_QUERY_KEYS.getConsulteeTeams], getConsulteeTeams, QueryDefaults);
